import Sortable from "stimulus-sortable";
import Toastify from "toastify-js";

export default class extends Sortable {
  connect() {
    super.connect();
  }

  // Override the onUpdate method to send all IDs at once
  async onUpdate(event) {
    if (this.element.dataset.sortableUpdateUrl) {
      // Get all items in their new order
      const items = Array.from(event.target.children);
      const ids = items.map((item) => item.dataset.id).filter(Boolean);

      const csrfToken = document.querySelector(
        'meta[name="csrf-token"]',
      ).content;

      await fetch(this.element.dataset.sortableUpdateUrl, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({ ids }),
      });
    } else {
      super.onUpdate(event);
    }
  }
}
